import { useSelector } from "react-redux";
import { ProgressCircle } from "@adobe/react-spectrum";
import "./style.css";
import { RootState } from "../../store/storeConfig";

export default ({ checkLoading }: { checkLoading: string }) => {
  const isLoading = useSelector((state: RootState) => state.common.isLoading);

  if (checkLoading === "loading" && isLoading) {
    return (
      <div className="loaderBox">
        <ProgressCircle aria-label="Loading…" isIndeterminate />
      </div>
    );
  }

  return null;
};
